import { useState, useEffect } from 'react';
import { siteInfo } from '@/mocks/home';

interface HeaderProps {
  onNavClick: (id: string) => void;
}

export default function Header({ onNavClick }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '焦点专题', href: '#carousel' },
    { label: '精彩推荐', href: '#media' },
    { label: '热播剧集', href: '#cards' },
    { label: '最新动态', href: '#updates' },
    { label: '常见问题', href: '#faq' },
  ];

  const handleClick = (href: string) => {
    setMobileOpen(false);
    const id = href.replace('#', '');
    onNavClick(id);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a href="#hero" className="flex items-center gap-2 whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}>
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500"></i>
            </div>
            <span className={`text-lg font-heading font-bold tracking-wide ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              {siteInfo.name}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => handleClick('#media')}
              className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
              }`}
            >
              开始追剧
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-800' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => handleClick('#media')}
              className="mt-2 px-4 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-full text-center whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              开始追剧
            </button>
          </div>
        </div>
      )}
    </header>
  );
}